import { graphql, useStaticQuery } from 'gatsby'

export default function useDocumentCountry() {
	const result = useStaticQuery(
		graphql`
			query locationQuery {
				allContentfulTenaPaises {
					nodes {
						codigoDeDosLetras
						departamentos {
							nombre
							codigo
							id
						}
						ciudades {
							codigo
							codigoDepartamento
							id
							nombre
						}
					}
				}
			}
		`
	)

	const actualLocale = process.env.LOCALE || 'es-CO'
	const resultQuery = result?.allContentfulTenaPaises?.nodes

	const getCountryInfo = locale => {
		const resultCmsInfo = resultQuery?.filter(content =>
			locale.includes(content.codigoDeDosLetras)
		)[0]

		return resultCmsInfo
	}

	const currentCountryInfo = getCountryInfo(actualLocale)

	const mapListToOptions = ({ list = [], keyNames }) =>
		list.map(option => {
			const optionFormated = {
				[keyNames?.keyName || 'name']: option.nombre || option.name,
				[keyNames?.keyValue || 'value']: option.codigo || option.value,
			}
			return optionFormated
		}) || []

	const filterCitiesByDeparment = ({
		deparmentId,
		locale = actualLocale,
		mapToOptions = true,
	}) => {
		let options = getCountryInfo(locale).ciudades
		if (deparmentId) {
			options = options?.filter(
				city =>
					city.codigoDepartamento?.toString() === deparmentId?.toString() ||
					city.value?.toString() === deparmentId?.toString()
			)
		}
		if (mapToOptions) {
			return mapListToOptions(options)
		}
		return options
	}

	return {
		currentCountryInfo,
		actualCitiesList: currentCountryInfo.ciudades,
		actualDeparmentList: currentCountryInfo.departamentos,
		getCountryInfo,
		filterCitiesByDeparment,
		mapListToOptions,
	}
}
